import React, { useRef, useState } from 'react'
import { css } from 'emotion'
import { Grid, GridCell, Popover, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { AddIcon, AdminWorkspaceIcon, DocumentIcon } from 'assets/icons'
import contentTypeThemes from 'config/constants/contentTypeThemes'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import { useOrganization } from 'src/graphql/hooks'
import AddButton from './AddButton'

const PageActions = ({ editMenuOptions }) => {
   const addPopoverButton = useRef()
   const editPopoverButton = useRef()

   const [addPopoverIsOpen, setAddPopoverIsOpen] = useState(false)
   const [editPopoverIsOpen, setEditPopoverIsOpen] = useState(false)

   const { organization } = useOrganization()
   // TODO: Update this:
   // We currently omit discussion creation from this menu as it is not
   // a great experience to create discussion through Admin Workshpace
   // See PR #412
   const quickAddInitiativeTypes = organization.initiativeTypes.filter(t => t.enabled && t.class !== 'discussion')

   return (
      <View
         display="none[a-b] block[c-f]"
         position="fixed"
         bottom="18px"
         right="18px">
         <View
            height="42px"
            backgroundColor="rgba(40,40,40,0.97)"
            borderRadius="6px">
            <View
               ref={editPopoverButton}
               onClick={() => setEditPopoverIsOpen(true)}
               position="relative"
               float="left"
               display="flex"
               alignItems="center"
               height="42px"
               padding="0px 21px 1px 21px"
               className={css`
                  border-top-left-radius: 6px;
                  border-bottom-left-radius: 6px;
                  cursor: pointer;

                  &:hover {
                     background-color: #444;
                  }
               `}>
               <Text size="1.5" color="#fff">Edit</Text>
            </View>
            <View
               float="left"
               position="relative"
               marginLeft="1px"
               marginRight="1px"
               height="24px"
               margin="9px 0px"
               borderRight="1px solid rgba(255,255,255,0.1)"
            />
            <View
               ref={addPopoverButton}
               onClick={() => setAddPopoverIsOpen(true)}
               position="relative"
               float="left"
               display="flex"
               justifyContent="center"
               alignItems="center"
               height="42px"
               width="42px"
               className={css`
                  border-top-right-radius: 6px;
                  border-bottom-right-radius: 6px;
                  cursor: pointer;

                  &:hover {
                     background-color: #444;
                  }
               `}>
               <AddIcon
                  width="14px"
                  height="14px"
                  color="#ddd"
               />
            </View>
         </View>
         <Popover
            anchorElement={editPopoverButton.current}
            anchorOriginHorizontal="right"
            anchorOriginVertical="bottom"
            backgroundColor="rgba(40,40,40,0)"
            width="270px"
            onBodyClick={() => setEditPopoverIsOpen(false)}
            open={editPopoverIsOpen}>
            <View
               backgroundColor="rgba(40,40,40,0.97)"
               borderRadius="8px"
               marginBottom="6px"
               style={{ overflow: 'hidden' }}>
               <Link to="/settings">
                  <ListMenuButton
                     name="Admin Workspace"
                     description="Edit your site settings"
                     icon={(
                        <AdminWorkspaceIcon
                           width="16px"
                           height="16px"
                           color="#aaa"
                        />
                     )}
                  />
               </Link>
               {organization.slug !== 'gns3' && editMenuOptions}
            </View>
         </Popover>
         <Popover
            anchorElement={addPopoverButton.current}
            anchorOriginHorizontal="right"
            anchorOriginVertical="bottom"
            backgroundColor="rgba(40,40,40,0)"
            width="270px"
            onBodyClick={() => setAddPopoverIsOpen(false)}
            open={addPopoverIsOpen}>
            <View
               backgroundColor="rgba(40,40,40,0.97)"
               borderRadius="8px"
               padding="12px"
               marginBottom="6px"
               style={{ overflow: 'hidden' }}>
               {!organization.currentUserCanEdit && (
                  <View width="100%" textAlign="center" padding="30px">
                     <Text size="1.5" color="#fff">
                        You must be a Site Admin to add new content
                     </Text>
                  </View>
               )}
               {organization.currentUserCanEdit && (
                  <Grid columns="3" spacing="0px">
                     <GridCell colspan="3">
                        <View
                           width="100%"
                           textAlign="center"
                           borderBottom="1px solid rgba(255,255,255,0.1)"
                           marginBottom="12px"
                           padding="6px 0px 12px 0px">
                           <Text size="2" weight="medium" color="#fff">Create New</Text>
                        </View>
                     </GridCell>
                     <GridCell>
                        <AddButton
                           name="Custom Page"
                           linkTo="/settings/content/pages/unpublished/create"
                           icon={(
                              <DocumentIcon
                                 width="18px"
                                 height="18px"
                                 color="#aaa"
                              />
                           )}
                        />
                     </GridCell>
                     {quickAddInitiativeTypes.map((type) => {
                        const Icon = contentTypeThemes[type.class]?.icon

                        return (
                           <GridCell key={type.id}>
                              <AddButton
                                 name={type.nameSingular}
                                 linkTo={`/settings/content/initiativeType/${type.id}/active/create`}
                                 icon={Icon && (
                                    <Icon
                                       width="18px"
                                       height="18px"
                                       color="#aaa"
                                    />
                                 )}
                              />
                           </GridCell>
                        )
                     })}
                  </Grid>
               )}
            </View>
         </Popover>
      </View>
   )
}

PageActions.propTypes = {
   editMenuOptions: PropTypes.node
}

PageActions.defaultProps = {
   editMenuOptions: undefined
}

export default PageActions
